export function formatToBrowserTime(utcTimestamp, use24Hour = false, showMillis = false) {
  // return empty for falsy input
  if (!utcTimestamp) return "";

  const date = new Date(utcTimestamp);
  // invalid date guard
  if (isNaN(date.getTime())) return "";

  const pad = (num, size = 2) => String(num).padStart(size, "0");

  const day = pad(date.getDate());
  const month = pad(date.getMonth() + 1);
  const year = date.getFullYear();

  const hours24 = date.getHours();
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());
  const millis = pad(date.getMilliseconds(), 3);

  // choose hours part and AM/PM if needed
  let hoursPart;
  let ampm = "";

  if (use24Hour) {
    hoursPart = pad(hours24);
  } else {
    hoursPart = pad(hours24 % 12 || 12); // convert 0 -> 12
    ampm = hours24 >= 12 ? "PM" : "AM";
  }

  // place milliseconds immediately after seconds (if requested)
  let time = `${hoursPart}:${minutes}:${seconds}`;
  if (showMillis) time += `.${millis}`;
  if (!use24Hour) time += ` ${ampm}`;

  return `${month}/${day}/${year} ${time}`;
}

export function formatToUtcIso(input, floorSeconds = true) {
  if (!input) return "";

  const date = new Date(input);
  if (isNaN(date.getTime())) return "";

  if (floorSeconds) date.setSeconds(0, 0);

  const pad = (num, size = 2) => String(num).padStart(size, "0");

  const year = date.getUTCFullYear();
  const month = pad(date.getUTCMonth() + 1);
  const day = pad(date.getUTCDate());
  const hours = pad(date.getUTCHours());
  const minutes = pad(date.getUTCMinutes());
  const seconds = pad(date.getUTCSeconds());
  const millis = String(date.getUTCMilliseconds()).padStart(3, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${millis}000+00:00`;
}

